import React, { createRef, useState } from 'react';
import { DocumentUploadModal } from '@/types/modal';
import { useTranslation } from 'react-i18next';
import { useUploadDocument } from '@/hooks/documents';
import { ErrorModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import { Box, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { HiddenFile } from '@/components/molecules/common/Form';
import styles from './Modal.module.scss';
const View: React.FC<{ modal: DocumentUploadModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { type, onClose } = modal;
  const submitR = useUploadDocument(type);
  const [file, setFile] = useState<File | null>(null);
  const imageRef = createRef<HTMLInputElement>();

  const handleChange = () => {
    imageRef.current?.click();
  };
  const handleDelete = () => {
    setFile(null);
  };
  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.update_item_description.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.update_item_description.title')}
        onClose={onClose}
      />
    );
  }

  const body = (
    <>
      <Box sx={{ maxWidth: '300px' }}>
        <Typography
          variant="body1"
          sx={{ fontSize: '0.85rem' }}
        >
          {t('modal.update_document.description')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '300px',
          height: '100px',
          margin: '0 auto',
          border: '1px dashed lightgray',
        }}
      >
        <UploadFileIcon
          sx={{ fontSize: 24, width: '3rem' }}
          color="primary"
        />
        {file ? (
          <>
            <Box sx={{ display: 'inline-grid', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
              <Typography
                variant="body1"
                sx={{ fontSize: '0.75rem' }}
                noWrap
              >
                {file.name}
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: '0.6rem' }}
                color="grey"
                noWrap
              >
                {file.size}kb
              </Typography>
            </Box>
            <IconButton onClick={handleDelete}>
              <CloseIcon />
            </IconButton>
          </>
        ) : (
          <>
            <Typography
              sx={{ fontSize: 13, mt: 1, width: '14rem' }}
              onClick={handleChange}
            >
              {t('modal.update_document.uploadNote')}
            </Typography>
            <button
              onClick={handleChange}
              className={styles.uploadButton}
            >
              <Typography
                fontWeight="bold"
                variant="body1"
                sx={{ fontSize: '0.85rem' }}
                noWrap
              >
                {t('modal.update_document.upload')}
              </Typography>
            </button>
            <HiddenFile
              reference={imageRef}
              accept="application/pdf"
              onChange={setFile}
            />
          </>
        )}
      </Box>
    </>
  );

  return (
    <StandardModal
      title={t(`modal.update_document.${type}.title`)}
      onClose={onClose}
      onSubmit={() => {
        submitR.mutate({
          file,
        });
      }}
      submittable={file !== null && file.size <= 10000000}
      body={body}
      containerStyle={{ maxWidth: 650 }}
      modalName="update_document"
    />
  );
};

export default View;
